<template>
    <div
        class="apprentice-simple-card"
        v-if="
            !groupIdIn ||
            !this.subAssignmentIn.hasAssignmentCooperation() ||
            this.subAssignmentIn.hasConfirmedPartnerUser($authUser.id) ||
            !$authUser.isStudent()
        ">
        <design-2021-assignment-show-sub-assignment-header-component
            :sub-assignment-in="subAssignmentIn"
            :assignment-status-in="assignmentStatusIn"
            :project-id="projectId"
            :selected-page-id-in="selectedPageIdIn"
            :view-type="viewType">
        </design-2021-assignment-show-sub-assignment-header-component>

        <design-2021-assignment-show-sub-assignment-feedback-component
            v-if="projectId && subAssignmentIn.hasFeedback()"
            :assignment-id-in="assignmentIdIn"
            :sub-assignment-in="subAssignmentIn"
            :project-id="projectId">
        </design-2021-assignment-show-sub-assignment-feedback-component>

        <design-2021-assignment-show-sub-assignment-list-view-component
            v-if="viewType === 1"
            :assignment-in="assignmentIn"
            :sub-assignment-in="subAssignmentIn"
            :can-answer="canAnswer"
            :is-example-in="isExampleIn"
            :project-id="projectId"
            :group-type-id-in="groupTypeIdIn"
            :assignment-status-in="assignmentStatusIn"
            @submitted="submitted"
            :profile-categories-in="profileCategoriesIn">
        </design-2021-assignment-show-sub-assignment-list-view-component>

        <design-2021-assignment-show-sub-assignment-paged-view-component
            v-if="viewType === 2"
            :assignment-in="assignmentIn"
            :sub-assignment-in="subAssignmentIn"
            :can-answer="canAnswer"
            :project-id="projectId"
            :assignment-status-in="assignmentStatusIn"
            :selected-page-id-in="selectedPageIdIn"
            :is-example-in="isExampleIn"
            @page-changed="changedSelectedPageId($event)"
            @submitted="submitted"
            :profile-categories-in="profileCategoriesIn">
        </design-2021-assignment-show-sub-assignment-paged-view-component>
    </div>
    <div
        class="apprentice-simple-card"
        v-else-if="
            !this.subAssignmentIn.hasAssignmentPartnerForUser($authUser.id) &&
            this.subAssignmentIn.assignment_cooperations[0].coop_maker_type !== 'student'
        ">
        <div class="description">Je kan aan de slag met deze opdracht zodra de docent groepen heeft ingedeeld.</div>
    </div>
    <div
        class="apprentice-simple-card create-group"
        v-else-if="!this.subAssignmentIn.hasAssignmentPartnerForUser($authUser.id)">
        <div class="description">Deze deelopdracht moet in een groepje gemaakt worden.</div>
        <b-button
            v-b-modal="'assignment-show-sub-assignment-partner-create-modal-' + subAssignmentIn.id"
            variant="primary"
            >Groepje maken
        </b-button>
        <design-2021-assignment-show-sub-assignment-partner-create-modal-component
            :sub-assignment-in="subAssignmentIn"
            :group-id-in="groupIdIn"
            :project-id-in="projectId">
        </design-2021-assignment-show-sub-assignment-partner-create-modal-component>
    </div>
    <div v-else>
        <design-2021-assignment-show-sub-assignment-partner-confirm-component :sub-assignment-in="subAssignmentIn">
        </design-2021-assignment-show-sub-assignment-partner-confirm-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-assignment-show-sub-assignment-component',
    props: [
        'assignmentIn',
        'subAssignmentIn',
        'projectId',
        'assignmentStatusIn',
        'selectedSubAssignmentIdIn',
        'selectedPageIdIn',
        'profileCategoriesIn',
        'viewType',
        'assignmentIdIn',
        'groupIdIn',
        'isExampleIn',
        'groupTypeIdIn',
    ],
    computed: {
        showFeedback() {
            if (!this.projectId) {
                return false;
            }

            return this.subAssignmentIn.feedback && this.subAssignmentIn.feedback.text;
        },
        canAnswer() {
            if (!this.projectId) {
                return false;
            }

            return !this.subAssignmentIn.hasStatus() || this.subAssignmentIn.getStatus().isWaitingForSubmit();
        },
    },
    methods: {
        changedSelectedPageId(id) {
            this.$emit('selected-page', id);
        },
        submitted(type) {
            this.$emit('submitted', type);
        },
    },
};
</script>

<style scoped lang="scss">
.list-group-item {
    border: none;
    font-size: 0.875rem;
}

.list-group-item:hover,
.list-group-item.active {
    background-color: #fff;
    color: #212529;
    font-weight: bold;
}

.nav-list-panel-header > a {
    text-align: left;
    background-color: #fff;
    border: none;
}

.nav-list-panel-header > a:hover,
.nav-list-panel-header > a:active,
.nav-list-panel-header > a.active,
.nav-list-panel-header > a:not(:disabled):active,
.nav-list-panel-header > a:not(:disabled):active:focus,
.nav-list-panel-header > a[aria-expanded='true'] {
    color: #212529;
    background-color: #e8eff4bf;
    box-shadow: none;
}

.nav-list-panel-header a.btn,
.nav-list-panel-header a.btn:not(.btn-inverse-light) {
    color: #212529;
}

.nav-list-panel-body {
    padding-top: 0;
    padding-bottom: 0;
}

.view-type {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
}

.view-type i {
    font-size: 1.125rem;
    cursor: pointer;
    padding: 8px;
    background-color: rgba(0, 123, 255, 0.2);
    color: #007bff;
    width: 35px;
}

.view-type i.active,
.view-type i:hover {
    background-color: #007bff;
    color: #fff;
}

.examine {
    margin-left: 10px;
    display: flex;
}

.examine .btn:not(:last-of-type) {
    margin-right: 10px;
}

.assignments {
    border: 1px solid #eee;
}

.header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: center;
    align-items: baseline;
    margin-bottom: 21px;
}

.btn-nav-toggle > .btn {
    background-color: transparent;
    border: none;
    box-shadow: none;
    height: 34px;
}

.btn-nav-toggle > .btn:hover {
    background-color: #d7deec;
}

.btn-nav-toggle .btn i {
    font-size: 0.8125rem;
    color: #212529;
}

.content {
    display: flex;
    flex-direction: column;
}

.actions {
    display: flex;
    align-items: center;
}

.due-date {
    color: #757575;
}

.subassignment-rating-result {
    flex: 1 0 100%;
    margin-top: 5px;
}

.subassignment-rating-result > span {
    color: #212529;
    font-weight: 500;
    font-size: 0.875rem;
}

.subassignment-rating-result .badge {
    color: #fff;
}

.nav-wrapper {
    display: flex;
    align-self: baseline;
}

.status {
    margin-right: 16px;
    font-size: 0.875rem;
    align-self: center;
}

.feedback {
    margin-bottom: 21px;
}

.sub-assignment-header > a {
    background-color: transparent;
    text-align: left;
    border: none;
}

.sub-assignment-header > a:hover,
.sub-assignment-header > a[aria-expanded='true'] {
    color: #212529;
}

.sub-assignment-header > a:hover,
.sub-assignment-header > a[aria-expanded='true']:hover {
    background-color: #eaeaf1;
}

.sub-assignment-header > a[aria-expanded='true'] {
    background-color: #f6f6f6;
}

.sub-assignment-content {
    border-bottom: 1px solid #eee;
}

.assignment-navigate {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-top: 30px;
    margin-bottom: 45px;
}

.assignment-navigate .next i,
.assignment-navigate .previous i {
    vertical-align: middle;
}

.create-group {
    .description {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
        font-size: $base-font-size;
        margin-bottom: $grid-gutter-width;
    }
}
</style>
